@if (item.show) {
  <a class="nav-link" matRipple (click)="toggleOpen($event, item.title)">
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title">{{item.title | translate}}</span>
    @if (item.badge) {
      <span class="nav-link-badge"
        [ngStyle]="{'background-color': '#F44336','color': 'white'}">
        {{item?.badge?.title ? item?.badge?.title : item?.badge}}
      </span>
    }
    <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
  </a>
  @if (isOpen) {
    <div class="children" style="display: block; height: auto">
      @for (item of item.children; track item) {
        @if (item.type=='item') {
          <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
        }
        @if (item.type=='collapse') {
          <fuse-nav-vertical-collapse [item]="item"></fuse-nav-vertical-collapse>
        }
        @if (item.type=='group') {
          <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
        }
      }
    </div>
  }
}

